@if (isDeepModel(config.modelAlias)) {
  <div class="deep-label">
    Deep <i class="fa-solid fa-sparkles"></i>
  </div>
}

<div
  class="alias-label"
  [class.blue]="isDeepModel(config.modelAlias)"
  [innerText]="config.modelAlias ? getAliasName(config.modelAlias) : ''"
></div>
